import { useEffect, useState } from 'react';

const loadedListeners = new Set<() => void>();

export function markBusinessLandingLoaded() {
  loadedListeners.forEach((listener) => listener());
}

export default function useBusinessLandingTransition(active: boolean) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!active) {
      setLoaded(false);
      return;
    }

    const handleLoaded = () => setLoaded(true);
    loadedListeners.add(handleLoaded);
    return () => {
      loadedListeners.delete(handleLoaded);
    };
  }, [active]);

  return loaded;
}
